import utils from '../app/util.js'

export const loginApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/passport/login', data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

// 邮箱注册验证码
export const changeEmailCode = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/common/update-email/code', data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
};

export const sendCodeApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/common/register/code', data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const registerApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/passport/register/email', data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const resetApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/sys/sys-user/update-pwd-email', data, 'put').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const searchCodeApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/aishiwei/asw-warranty/qualityQuery', data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const checkedskuNoApi = (skuNo) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/order-info/addValidate/${skuNo}`, {}).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const getPriceApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/order-info/price/${data.skuno}`, null, 'get').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const buyApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/order-info/add`, data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const activeApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/warrant-activation/add`, data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const getOrderApi = () => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/order-info/list`, null, 'get').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const uploadFileApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/order-info/uploadPayment/${data.id}`, data.file, 'post', 'json', { isform: true }).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const getCustomerInfoByUserIdApi = () => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/customer-info/getCustomerInfoByUserId`, null, 'get').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const editUserApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/customer-info/edit`, data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const updateEmailApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/sys/sys-user/update-email', data, 'put').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const updatePwdApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/sys/sys-user/update-pwd', data, 'put').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}
export const getPath = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/order-info/download/${data.isn}`, null, 'get').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}



// WEBPACK FOOTER //
// ./src/deps/api.js